import { Box } from "@mui/material";
import { useId } from "react";
import { EMPTY_SX } from "../../../utils/empty-sx";

import type { SxProps, Theme } from "@mui/material";
import type { FC, ReactNode } from "react";

/** Fills the MUI icons inside it with the brand gradient, left to right. */
export const GradientIcon: FC<{ children: ReactNode; sx?: SxProps<Theme> }> = ({
  children,
  sx = EMPTY_SX,
}) => {
  // Its own id, so icons on the same page don't fill from each other's gradient.
  const gradientId = useId();

  return (
    <Box
      component="span"
      sx={[
        { display: "inline-flex", "& .MuiSvgIcon-root": { fill: `url(#${gradientId})` } },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <svg
        width="0"
        height="0"
        aria-hidden="true"
        focusable="false"
        style={{ position: "absolute" }}
      >
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00B6EF" />
            <stop offset="100%" stopColor="#C24599" />
          </linearGradient>
        </defs>
      </svg>
      {children}
    </Box>
  );
};
